import type { Observable } from 'rxjs';
import { Subject, filter, map } from 'rxjs';

import type { BuzzerOnlineDevicesNotifications } from './types';

export enum EventType {
  DEVICE_CONNECTED = 'device_connected',
  DEVICE_DISCONNECTED = 'device_disconnected',
  STREAM_EVENT = 'stream_event',
  DEVICE_UPDATED = 'device_updated',
}

export interface EventPayload {
  type: EventType;
  payload: BuzzerOnlineDevicesNotifications;
}

const eventBus$ = new Subject<EventPayload>();

export const publishEvent = (type: EventType, payload: EventPayload['payload']): void => {
  eventBus$.next({ type, payload });
};

export const onEvent = (type: EventType): Observable<BuzzerOnlineDevicesNotifications> => {
  return eventBus$.pipe(
    filter((event) => event.type === type && event.payload !== undefined && event.payload !== null),
    map((event) => event.payload)
  );
};

export { eventBus$ };
